export const EMOTION_URL = "https://mood-detection-api.vercel.app/api/predict-emotion";
export const TIRED_URL = "https://mood-detection-api.vercel.app/api/predict-tired";

export const COOLDOWN_SECONDS = 5;

export const EMOTIONS = {
    "neutral": {
        value: "neutral",
        display: "Neutral 😶",
        primaryColor: "#E1BBC9",
        secondaryColor: "#BBE1D3",
        waveColorA: "rgba(153, 50, 204, 0.3)",
        waveColorB: "rgba(30, 144, 225, 0.3)",
        waveColorC: "rgba(220, 20, 60, 0.3)",
        textColor: "#1B1F3B",
        textColorAlt: "#FFFFF2",
    },
    "tired": {
        value: "tired",
        display: "Tired 😴",
        primaryColor: "#191D32",
        secondaryColor: "#322E19",
        waveColorA: "rgba(124, 152, 179, 0.3)",
        waveColorB: "rgba(172, 203, 225, 0.3)",
        waveColorC: "rgba(206, 229, 242, 0.3)",
        textColor: "#FFFFF2",
        textColorAlt: "#1B1F3B",
    },
    "happy": {
        value: "happy",
        display: "Happy 😃",
        primaryColor: "#FEC601",
        secondaryColor: "#D11149",
        waveColorA: "rgba(238, 171, 196, 0.3)",
        waveColorB: "rgba(199, 153, 166, 0.3)",
        waveColorC: "rgba(75, 40, 64, 0.3)",
        textColor: "#1B1F3B",
        textColorAlt: "#FFFFF2"
    },
    "sad": {
        value: "sad",
        display: "Sad 😔",
        primaryColor: "#4E4C67",
        secondaryColor: "#65674C",
        waveColorA: "rgba(154, 152, 181, 0.3)",
        waveColorB: "rgba(160, 185, 198, 0.3)",
        waveColorC: "rgba(165, 248, 211, 0.3)",
        textColor: "#FFFFF2",
        textColorAlt: "#1B1F3B",
    },
    "angry": {
        value: "angry",
        display: "Angry 😠",
        primaryColor: "#A62329",
        secondaryColor: "#E5F77D",
        waveColorA: "rgba(54, 17, 52, 0.3)",
        waveColorB: "rgba(243, 145, 160, 0.3)",
        waveColorC: "rgba(237, 230, 242, 0.3)",
        textColor: "#FFFFF2",
        textColorAlt: "#1B1F3B",
    },
    "disgust": {
        value: "disgust",
        display: "Disgusted 🤢",
        primaryColor: "#086375",
        secondaryColor: "#BFAE48",
        waveColorA: "rgba(54, 5, 104, 0.3)",
        waveColorB: "rgba(230, 52, 98, 0.3)",
        waveColorC: "rgba(254, 95, 85, 0.3)",
        textColor: "#FFFFF2",
        textColorAlt: "#1B1F3B",
    },
    "fear": {
        value: "fear",
        display: "Afraid 😨",
        primaryColor: "#897C80",
        secondaryColor: "#7C8985",
        waveColorA: "rgba(115, 0, 113, 0.3)",
        waveColorB: "rgba(25, 25, 35, 0.3)",
        waveColorC: "rgba(251, 254, 249, 0.3)",
        textColor: "#1B1F3B",
        textColorAlt: "#FFFFF2",
    },
    "surprise": {
        value: "surprise",
        display: "Surprised 😮",
        primaryColor: "#C5D86D",
        secondaryColor: "#806DD8",
        waveColorA: "rgba(247, 86, 124, 0.3)",
        waveColorB: "rgba(37, 161, 142, 0.3)",
        waveColorC: "rgba(16, 37, 66, 0.3)",
        textColor: "#1B1F3B",
        textColorAlt: "#FFFFF2",
    },
}

export const DEFAULT_PLAYLISTS = {
    "neutral": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/5BZ4aodJTESrcaGQERLzjV?si=535c34478d434568",
            "https://open.spotify.com/track/1U8tjMoPRPAkNkunfH5OxD?si=48bb550e4bf14f89",
            "https://open.spotify.com/track/1AwXvRDkuXRmXgzxLW10lX?si=a449504d791e4b51",
            "https://open.spotify.com/track/3TEb0AU6wup3IrWp9CPc1v?si=a2b873050f5b4043",
            "https://open.spotify.com/track/4Vi2qeM4UPviTzuKohUIr3?si=7d7445130e8543d6",
            "https://open.spotify.com/track/1hIokS8624s7tpeZuWclRK?si=8160d56c74a14a2f",
            "https://open.spotify.com/track/4kC81FbJoMaD3Fr0kLEzHr?si=c3cbe7d35cec4202",
            "https://open.spotify.com/track/1rp1RDGaMNXbDoKZDVEQHc?si=c2f0d2b2eab2448e",
        ],
    },
    "happy": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/4Dvkj6JhhA12EX05fT7y2e?si=c19c048f22284fa5",
            "https://open.spotify.com/track/1rqqCSm0Qe4I9rUvWncaom?si=551199d66a5a48db",
            "https://open.spotify.com/track/5Odq8ohlgIbQKMZivbWkEo?si=f6624cf29fd64b7f",
            "https://open.spotify.com/track/4cluDES4hQEUhmXj6TXkSo?si=d453ea4f0c7b459a",
            "https://open.spotify.com/track/1mea3bSkSGXuIRvnydlB5b?si=826f6412c1f04045",
            "https://open.spotify.com/track/4fYte8ZvTK14NEhAOZocBi?si=fe664c0782d742d1",
            "https://open.spotify.com/track/1XGmzt0PVuFgQYYnV2It7A?si=96a19a8031eb4892",
            "https://open.spotify.com/track/38DgNqC7TQkZ3Ih5Vz6K0Q?si=ee55c328c57f4e21",
        ],
    },
    "tired": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/2Cz4rYup2tiEdyGX0IWnH7?si=6f4cc5d262284f90",
            "https://open.spotify.com/track/7gqe2hMeAKoxif1jrPihCv?si=d4302cc96d5f4dad",
            "https://open.spotify.com/track/2bQr2fVvAnyq5Wg7l1xkhW?si=35708c396619405f",
            "https://open.spotify.com/track/2tTam1DLtJL6hqFd4JIBTu?si=6c2155c9b5604e37",
            "https://open.spotify.com/track/4S2KNfRivsduJPWI52oJVf?si=a1bca34ba58645ab",
            "https://open.spotify.com/track/4T7oDgtpVj7mvGseuU7nyA?si=7986c7444b8f4016",
            "https://open.spotify.com/track/4bPJW9pNtuvMujHnbxEN1g?si=d143da95d1ce44de",
            "https://open.spotify.com/track/1KohJWIWwDDw7mBxs2wv90?si=29563100a1834740",
        ], 
    },
    "sad": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/13NC44aS3d0EFF58oVQ8T7?si=6926583e5caf4f1c",
            "https://open.spotify.com/track/3U4isOIWM3VvDubwSI3y7a?si=aab1c4ba3f884118",
            "https://open.spotify.com/track/0u2P5u6lvoDfwTYjAADbn4?si=e43a25f7e4b34438",
            "https://open.spotify.com/track/0VQjTLPG8l3egUHmIxe265?si=c64c8d072dad48ba",
            "https://open.spotify.com/track/6xGruZOHLs39ZbVccQTuPZ?si=e9b7fbfb7ff54adf",
            "https://open.spotify.com/track/74eJR4gwG1ZmG4BFkbrOlA?si=4bf8b91b9dc2453a",
            "https://open.spotify.com/track/5uCax9HTNlzGybIStD3vDh?si=c6da1ecd0c7f4e3e",
            "https://open.spotify.com/track/4JehYebiI9JE8sR8MisGVb?si=5c415531bc1b4da7",
        ],
    },
    "angry": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/2pxAohyJptQWTQ5ZRWYijN?si=101c3222a09c4048",
            "https://open.spotify.com/track/33c2SurTuBpaWAW9YKlvqC?si=7f05731bf8c44fab",
            "https://open.spotify.com/track/1jzDzZWeSDBg5fhNc3tczV?si=efd50d2ec20d4a78",
            "https://open.spotify.com/track/5NIPsWpDjJTFBoPxCUUeXp?si=e7eb8c4475cc43bd",
            "https://open.spotify.com/track/1RQwcsdHIW5p86cx8zuf1I?si=c45bf893119544b2",
            "https://open.spotify.com/track/61dTqhd46yMkSWmC5LAh5F?si=b5488bc1ac4744f7",
            "https://open.spotify.com/track/4wBxOGbbVIVkCJGCM5zwVo?si=4155004c21184e78",
            "https://open.spotify.com/track/3HzWxmvpQU3QHQ59zw1X4V?si=dd2b8bd96d0e434a",
        ],
    },
    "surprise": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/4cOdK2wGLETKBW3PvgPWqT?si=575d065658134bbd",
        ],
    },
    "disgust": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/6foY66mWZN0pSRjZ408c00?si=59fde61bff2142ee",
            "https://open.spotify.com/track/6iy4PoAuZBMvtrlDX4VxC7?si=9c079e8fa2254181",
            "https://open.spotify.com/track/7mldq42yDuxiUNn08nvzHO?si=dd054965bd0e4edc",
            "https://open.spotify.com/track/5KqldkCunQ2rWxruMEtGh0?si=1519a143807c4864",
            "https://open.spotify.com/track/0i5el041vd6nxrGEU8QRxy?si=48b62f0363594f52",
            "https://open.spotify.com/track/5kNe7PE09d6Kvw5pAsx23n?si=98f4d64e3e3f4925",
        ],
    },
    "fear": {
        "url": "",
        "name": "",
        "image": "",
        "songs": [
            "https://open.spotify.com/track/4WJ7UMD4i6DOPzyXU5pZSz?si=05102f2293f04d66",
            "https://open.spotify.com/track/1UvaZaHkh3D9AkmBrrnbFg?si=d0e10249d3704ccb",
            "https://open.spotify.com/artist/5zCaQxjl110XTrm4LQ1CxY?si=782271624fc84e95",
            "https://open.spotify.com/track/1cd7Pft3rfZ0hmaOLI0EDB?si=3999c8db5f0d4619",
            "https://open.spotify.com/track/4gaWbVsdmvsNHktWWg9qcq?si=a023737c76cf45f2",
            "https://open.spotify.com/track/0kdhTbVFVusJcBm4bWjrKm?si=cc830e9b59774dfd",
        ],
    },
};